// Prod's NUXT_PUBLIC_HOST is the origin host behind www.myce.de. Public URLs (og tags, canonical,
// hreflang, sitemap) must use the public domain, otherwise shares and search results expose the origin.
const publicHostMap = {
    'prod-new.myce.de': 'www.myce.de'
}

export const resolveSiteUrl = (host) => {
    const publicHost = publicHostMap[host] || host

    return publicHost.startsWith('localhost') ? `http://${publicHost}` : `https://${publicHost}`
}
